import s from '../solution-rate-reviews.scss';
import type { WithTranslation as WithTranslationProps } from 'react-i18next';
import { composer } from '../../../../../component-decorators/composer';
import React from 'react';
import { SolutionReview } from './solution-review';
import { ReviewsSectionHeader } from './reviews-section-header';
import {
  Box,
  Card,
  TextButton,
  Divider,
  Layout,
  Cell,
} from '@wix/design-system';
import type {
  ISolutionReview,
  ISolutionReviewsDTO,
} from '../../../../../types/common/marketplace';
import type { InjectedExperimentsProps } from '@wix/wix-experiments-react';
import { HelpfulReview } from './helpful-review';
import { useConfigContext } from '../../../../../config-context';

export const dtoToSolutionReviews = (
  solutionDto: ISolutionReviewsDTO,
): ISolutionReview[] => {
  return solutionDto.body.reviews;
};

export interface ISolutionReviewsProps
  extends Partial<WithTranslationProps>,
    Partial<InjectedExperimentsProps> {
  reviews?: ISolutionReview[];
  loadMore?: any;
  hideLoadMoreBtn?: boolean;
  editMode?: { userReview: ISolutionReview; shouldDisplay: boolean };
  showDeletedLink?: boolean;
  sortBy?: any;
  afterPostRender?: any;
  numberOfReviews: number;
  developerName: string;
  developerIcon: string;
  appName: string;
  appId: string;
  averageRating: number;
  isEligibleForReviews?: boolean;
}

export const SolutionReviews = composer()
  .withExperiments()
  .withTranslation()
  .compose((props: ISolutionReviewsProps) => {
    const { isMobile } = useConfigContext();
    return (
      <Card className={s.solutionReviewsContainer}>
        <span vocab="https://schema.org/" typeof="Review">
          <Card.Content>
            <ReviewsSectionHeader
              editMode={props.editMode}
              showDeletedLink={props.showDeletedLink}
              afterPostRender={props.afterPostRender}
              sortBy={props.sortBy}
              reviews={props.numberOfReviews}
              isEligibleForReviews={props.isEligibleForReviews}
              appId={props.appId}
            />
            {isMobile && (
              <Box marginTop="15px" marginBottom="16px">
                <Divider />
              </Box>
            )}
            {props.reviews &&
              props.reviews.map((review, index, array) => {
                return (
                  <div key={review.id}>
                    <Layout>
                      <Cell span={12}>
                        <SolutionReview
                          ratingCount={props.numberOfReviews}
                          averageRating={props.averageRating}
                          appName={props.appName}
                          developerName={props.developerName}
                          developerIcon={props.developerIcon}
                          review={review}
                          key={review.id}
                          appId={props.appId}
                          index={index}
                        />
                        <HelpfulReview appId={props.appId} review={review} />
                      </Cell>
                    </Layout>
                    {props.hideLoadMoreBtn &&
                    index === array.length - 1 ? null : (
                      <div className={s.reviewDivider}>
                        <Divider />
                      </div>
                    )}
                  </div>
                );
              })}
            <Box align="center">
              {props.hideLoadMoreBtn ? null : (
                <TextButton dataHook="load-more" onClick={props.loadMore}>
                  {props.t('solution.page.reviewsViewMore')}
                </TextButton>
              )}
            </Box>
          </Card.Content>
        </span>
      </Card>
    );
  });
